import SnapshotCellWrapper from './SnapshotCellWrapper';

import { RadioBooleanRender } from './RadioBooleanRender';
import { useCheckSnapshotForRetailer } from 'pages/qa-spec/hooks';

const RadioBooleanSnapshot = (props) => {
  const { column, rowIndex, data, context } = props;

  const { snapshotGridValues } = context || {};

  const useSnapshot = useCheckSnapshotForRetailer();

  const cellSnapshotValue = snapshotGridValues?.[rowIndex]?.[column.colId];
  const rawCellValue = data?.[column.colId];

  const isHighlightChange = cellSnapshotValue !== rawCellValue && useSnapshot;

  return (
    <SnapshotCellWrapper
      isHighlightChange={isHighlightChange}
      snapshotValueRender={
        <>
          {cellSnapshotValue === null || cellSnapshotValue === undefined ? (
            'N/A'
          ) : (
            <RadioBooleanRender value={cellSnapshotValue} />
          )}
        </>
      }
    >
      <RadioBooleanRender {...props} />
    </SnapshotCellWrapper>
  );
};

export default RadioBooleanSnapshot;
